import React, {Component} from "react";
import "./GamesList.component.scss";
import {Components} from "@webtech/webtech-ui-react/build/webtech-ui";
import {ActionCreator} from "../../../../../actions/actions";
import {connect} from "react-redux";
import {gamesStoreSelectors} from "../../../store/store";
import {GamesActionCreators} from "../../../actions/actionCreators";
import Paginator from "../../../../../utils/Paginator/Paginator.component";
import GameCard from "../GameCard/GameCard.component";
import Drawer from "./../../../../../utils/Drawer/Drawer.component";
import CreateGame from "../CreateGame/CreateGame.component";
import {CreationModes} from "../../../reducers/creationMode.reducer";
import {Game} from "../../../reducers/games.reducer";
import {GameNavigation} from "../GameNavigation/GameNavigation.component";
import {checkPermission} from "./../../../../../utils/Authorization/authorization";
import {withRouter, RouteComponentProps} from "react-router-dom";

export interface GamesListProps extends RouteComponentProps {
    creationMode: any;
    updateCreationMode: ActionCreator;
    clearCreateGame: ActionCreator;
    getGames: ActionCreator;
    games: {
        results: Game[];
        count: number;
    };
    gamesLoading: boolean;
    updateCreatingGame: ActionCreator;
    editGame: ActionCreator;
    createGame: ActionCreator;
    gameCreationAttributesLoading: boolean;
    gameCreationAttributes: any;
    getGameCreationAttributes: ActionCreator;
}

export interface GamesListState {
    selectedType: number;
    selectedSoftwareHouse: string;
    currentPage: number;
    selectedStringSearch: string;
    selectedDeprecated: string;
}

const gameStatus = [
    {
        value: "",
        label: "All"
    },
    {
        value: 1,
        label: "Enabled"
    },
    {
        value: 0,
        label: "Deprecated"
    }
];

class GamesList extends Component<GamesListProps, GamesListState> {
    typeFilter: React.RefObject<Components.SelectMenu>;
    softwareHouseFilter: React.RefObject<Components.SelectMenu>;

    constructor(props) {
        super(props);
        this.typeFilter = React.createRef();
        this.softwareHouseFilter = React.createRef();

        this.state = {
            selectedType: null,
            selectedSoftwareHouse: null,
            selectedStringSearch: null,
            currentPage: 1,
            selectedDeprecated: ""
        };

        this.props.getGameCreationAttributes();
    }

    componentDidMount() {
        this.getGames()
    }

    getGames = () => {
        let type = this.state.selectedType
        if (type) {
            const gameType = this.props.gameCreationAttributes.gameTypes.results.find(att => att.id === type)
            const types = this.props.gameCreationAttributes.gameTypes.results.filter(att => att.name == gameType.name)
            type = types.map(att => att.id)
        }
        this.props.getGames({
            page: this.state.currentPage,
            top: 24,
            type: type,
            software_house: this.state.selectedSoftwareHouse,
            search: this.state.selectedStringSearch,
            deprecated: this.state.selectedDeprecated
        });
    }

    applyFilters = (value, field) => {
        let updatedState = {...this.state};
        updatedState[field] = value
        this.setState({
            ...updatedState,
            currentPage: 1
        }, this.getGames)
    }

    pageChange = newPage => {
        this.setState({
            currentPage: newPage
        }, this.getGames);
    };

    onClearFilters = () => {
        this.typeFilter.current.selectItem([]);
        this.typeFilter.current.setDisplayString("Choose Product Type");
        this.softwareHouseFilter.current.selectItem([]);
        this.softwareHouseFilter.current.setDisplayString(
            "Choose Software house"
        );
        this.setState({
            selectedType: null,
            selectedSoftwareHouse: null,
            selectedStringSearch: null,
            currentPage: 1,
            selectedDeprecated: ""
        });
    };

    onCreateSubmit = game => {
        this.props.createGame(game, {
            page: this.state.currentPage,
            top: 24,
            type: this.state.selectedType,
            software_house: this.state.selectedSoftwareHouse,
            search: this.state.selectedStringSearch
        });
    };

    onEditSubmit = game => {
        this.props.editGame(game, {
            page: this.state.currentPage,
            top: 24,
            type: this.state.selectedType,
            software_house: this.state.selectedSoftwareHouse,
            search: this.state.selectedStringSearch
        });
    };

    navigateToGame = url => {
        this.props.history.push(url);
    };

    renderGames() {
        if (this.props.gamesLoading) {
            return (
                <div className="col-12 games-list-loading">
                    <Components.LoadingRipple
                        width={"100px"}
                        height={"100px"}
                    />
                </div>
            );
        } else if (this.props.games.results.length === 0) {
            return (
                <div className="games-list-no-games">
                    No games to display. Please select different values to try
                    again.
                </div>
            );
        } else {
            return (
                <React.Fragment>
                    <div className="cards-container">
                        {this.props.games.results.map((game, key) => (
                            <GameCard
                                key={key}
                                game={game}
                                edit={this.editGame}
                                onClick={this.navigateToGame}
                            />
                        ))}
                    </div>

                    <div className="col-12 paginator-col">
                        <Paginator
                            currentPage={this.state.currentPage}
                            totalPages={
                                Math.floor(this.props.games.count / 24) + 1
                            }
                            onPageChange={this.pageChange}
                        />
                    </div>
                </React.Fragment>
            );
        }
    }

    closeCreateGame = () => {
        this.props.clearCreateGame();
    };

    createGame = () => {
        this.props.updateCreationMode(CreationModes.ADD_GAME);
    };

    editGame = game => {
        this.props.updateCreatingGame(
            {
                ...game,
                client: game.client ? game.client.id : undefined,
                feature: game.feature ? game.feature.id : undefined,
                game_type: game.game_type ? game.game_type.id : undefined,
                platform: game.platform ? game.platform.id : undefined,
                series: game.series ? game.series.id : undefined,
                trademark: game.trademark ? game.trademark.id : undefined
            },
            true
        );
        this.props.updateCreationMode(CreationModes.EDIT_GAME);
    };

    render() {
        const isLoading =
            this.props.gamesLoading ||
            this.props
                .gameCreationAttributesLoading;

        const gameTypes = []

        if (this.props.gameCreationAttributes.gameTypes && this.props.gameCreationAttributes.gameTypes.results) {
            this.props.gameCreationAttributes.gameTypes.results
                .map(att => {
                    if (!gameTypes.find(game => game.label === att.name)) {
                        gameTypes.push({
                            label: att.name,
                            value: att.id
                        });
                    }
                })
        }

        return (
            <div id="GamesList" className="content">
                <GameNavigation>
                    {(process.env.REACT_APP_BUILD_ENV === "PROD" || !process.env.REACT_APP_BUILD_ENV) &&
                        checkPermission("edit_games") && (
                            <div className="add-menu">
                                <a
                                    className="new-game red-btn"
                                    onClick={this.createGame}
                                >
                                    <span>New Game</span>
                                </a>
                            </div>
                        )}
                </GameNavigation>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="hall-filters">
                                <div id="GamesPageFiltersBox">
                                    <div className="row">
                                        <div className="adjustable-filters">
                                            <div className="game-filter">
                                                <label className="label">
                                                    Search
                                                </label>
                                                <input
                                                    className="input"
                                                    placeholder="Game name"
                                                    onChange={event =>
                                                        this.applyFilters(event.target.value, 'selectedStringSearch')}
                                                />
                                            </div>

                                            <div className="game-filter">
                                                <label className="label">
                                                    Product Type
                                                </label>
                                                <Components.SelectMenu
                                                    ref={this.typeFilter}
                                                    items={gameTypes}
                                                    noValueLabel="Choose Product Type..."
                                                    value={
                                                        this.state
                                                            .selectedType ||
                                                        null
                                                    }
                                                    onChange={event =>
                                                        this.applyFilters(event, 'selectedType')}
                                                />
                                            </div>

                                            <div className="game-filter">
                                                <label className="label">
                                                    Software House
                                                </label>
                                                <Components.SelectMenu
                                                    ref={
                                                        this.softwareHouseFilter
                                                    }
                                                    items={[
                                                        {
                                                            value: 1,
                                                            label: "Fabamaq"
                                                        },
                                                        {
                                                            value: 2,
                                                            label: "FBM Brasil"
                                                        }
                                                    ]}
                                                    noValueLabel="Choose option..."
                                                    value={
                                                        this.state
                                                            .selectedSoftwareHouse ||
                                                        null
                                                    }
                                                    onChange={event =>
                                                        this.applyFilters(event, 'selectedSoftwareHouse')
                                                    }
                                                />
                                            </div>

                                            <div className="game-filter">
                                                <label className="label">
                                                    Deprecation Status
                                                </label>
                                                <Components.CheckboxGroup
                                                    key={`checkbox-${this.state.selectedDeprecated}`}
                                                    items={gameStatus}
                                                    selected={
                                                        this.state
                                                            .selectedDeprecated
                                                    }
                                                    onChange={event =>
                                                        this.applyFilters(event, 'selectedDeprecated')
                                                    }
                                                />
                                            </div>

                                            <div>
                                                <button
                                                    className="clear-filters-btn"
                                                    onClick={
                                                        this.onClearFilters
                                                    }
                                                >
                                                    Clear All Filters
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div>
                        {isLoading ? (
                            <div className="games-list-loading">
                                <Components.LoadingRipple
                                    width={"100px"}
                                    height={"100px"}
                                />
                            </div>
                        ) : (
                            <div className="games-list-card">
                                <div className="games">
                                    <div className="row">
                                        {this.renderGames()}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                    {(this.props.creationMode == CreationModes.ADD_GAME ||
                        this.props.creationMode == CreationModes.EDIT_GAME) && (
                        <Drawer
                            title={
                                this.props.creationMode ==
                                CreationModes.ADD_GAME
                                    ? "New Game"
                                    : "Edit Game"
                            }
                            onClose={this.closeCreateGame}
                        >
                            <CreateGame
                                editGame={this.onEditSubmit}
                                createGame={this.onCreateSubmit}
                                attributes={this.props.gameCreationAttributes}
                            />
                        </Drawer>
                    )}
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creationMode: gamesStoreSelectors.creationMode(state),
    games: gamesStoreSelectors.games(state),
    gamesLoading: gamesStoreSelectors.gamesLoading(state),
    gameCreationAttributesLoading:
        gamesStoreSelectors.gameCreationAttributesLoading(state),
    gameCreationAttributes: gamesStoreSelectors.gameCreationAttributes(state)
});

const mapDispatchToProps = {
    updateCreationMode: GamesActionCreators.updateCreationMode,
    clearCreateGame: GamesActionCreators.clearCreateGame,
    getGames: GamesActionCreators.getGames,
    updateCreatingGame: GamesActionCreators.updateCreatingGame,
    editGame: GamesActionCreators.editGame,
    createGame: GamesActionCreators.createGame,
    getGameCreationAttributes: GamesActionCreators.getGameCreationAttributes
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(GamesList));
